import React from 'react';
const Button = React.memo((props) => {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { className: `${props.disabled ? "" : "hover:opacity-100"} opacity-90 bg-haikan-matching-red px-3 py-1 text-sm font-medium leading-5 text-white text-center transition-colors duration-150 border border-transparent rounded-md disabled:opacity-50 active:opacity-70 focus:outline-none focus:shadow-outline-red min-w-min whitespace-nowrap max-h-8 ${(_a = props.optionClass) !== null && _a !== void 0 ? _a : ""}`, onClick: props.onClick, disabled: props.disabled }, props.tag)));
});
export default Button;
